import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SwitchIcon extends PureComponent {
    static propTypes = {
        color: PropTypes.string,
        secondaryColor: PropTypes.string,
        size: PropTypes.number
    };

    static defaultProps = {
        color: '#8e8e8e',
        secondaryColor: '#fff',
        size: 50
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 300">
                <rect width={300} height={300} rx={15} ry={15} fill={color} />
                <rect x={102.74} y={71.98} width={99.44} height={164.17} rx={15} ry={15} fill={secondaryColor} />
                <path
                    d="M138 213.94c-3.56 0-6.45-3.2-6.45-7.14s2.88-7.14 6.45-7.14h28.94c3.56 0 6.45 3.2 6.45 7.14s-2.89 7.14-6.45 7.14z"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(SwitchIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SwitchIcon.js